module.exports = __webpack_public_path__ + "static/img/3.541222a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/3.png
// module id = mKgr
// module chunks = 0